module.exports = __webpack_public_path__ + "img/namao_icon.68d4db29.png";